import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from 'react-redux';
import { hideNudge, SEVEARITY_CONTS } from './nudgeReducer';
import MuiAlert from '@mui/material/Alert';
import Slide from '@mui/material/Slide';

function SlideTransition(props) {
    return <Slide {...props} direction="down" />;
}

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function Nudge() {
    const { show, message, severity } = useSelector(store => store.nudge)
    const dispatch = useDispatch()

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        dispatch(hideNudge())
    };

    const action = (
        <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleClose}
        >
            <CloseIcon fontSize="small" />
        </IconButton>
    );

    return (
        <div className='nudge'>
            <Snackbar
                open={show}
                autoHideDuration={6000}
                onClose={handleClose}
                action={action}
                TransitionComponent={SlideTransition}
                key={SlideTransition.name}
                anchorOrigin={{
                    horizontal: "center",
                    vertical: "top"
                }}>
                <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
                    {message}
                    {!message && severity === SEVEARITY_CONTS.error && "Something went wrong!"}
                    {!message && severity === SEVEARITY_CONTS.success && "Successful!"}
                </Alert>
            </Snackbar>
        </div>

    );
}
